import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, API_URL } from '../../../config/api';
import axiosService from '../../../services/axiosServicesVisit';

export const getSpecialtysList = createAsyncThunk('specialtys/fetchAll', async ({page,itemsPerPage,filter}) => {
  const params = new URLSearchParams({
    page,
    limit: itemsPerPage,
    search: filter.search,
  });
  
  if ([0, 1].includes(filter.status)) {
    params.append('status', filter.status);
  }
    const URL = `${API_URL}${API.SPECIALTYS.GETSPECIALTYS}?${params.toString()}`;
    return axiosService
      .get(URL)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);


export const addSpecialty = createAsyncThunk(
  'specialty/add',
  async (specialty) => {
    const URL = API_URL + API.SPECIALTYS.ADDSPECIALTY;
    return axiosService
      .post(URL, specialty)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const deleteSpecialty = createAsyncThunk(
  'specialty/delete',
  async (specialtyID) => {
    const URL = `${API_URL  + API.SPECIALTYS.ADDSPECIALTY}/${specialtyID}`;
    return axiosService
      .delete(URL)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const updateSpecialty = createAsyncThunk(
  'specialty/update',
  async ({ specialtyID, specialtyData }) => {
    const URL = `${API_URL  + API.SPECIALTYS.UPDATESPECIALTY}/${specialtyID}`;
    return axiosService
      .patch(URL, specialtyData)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getSpecialtyById = createAsyncThunk(
  'specialty/fetchById',
  async (specialtyID) => {
    const URL = `${API_URL  + API.SPECIALTYS.GETSPECIALTYBYID}/${specialtyID}`;
    return axiosService
      .get(URL)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getSpecialtiesForFilter = createAsyncThunk(
  'specialtys/getSpecialtiesForFilter',
  async (_, { rejectWithValue }) => {
    try {
      // On construit l'URL manuellement pour le nouvel endpoint.
      // Assurez-vous que API.SPECIALTYS.GETSPECIALTYS correspond bien à '/specialtys' dans votre config.
      const URL = `${API_URL}${API.SPECIALTYS.GETSPECIALTYS}/list`;
      const response = await axiosService.get(URL);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : 'Erreur inconnue');
    }
  }
);

